/**
 * Returns a callback that increments the pagination index.
 * @param {Element} component
 * @returns {Function}
 */
const handleIndexIncrementation = (component) => () => {
    const index = Number($(component).attr('data-index') || 0);
    const offset = Number($(component).attr('data-offset') || 1000);

    $(component).attr('data-index', index + offset);
};

export default handleIndexIncrementation;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/handleIndexIncrementation.js